import { openSxSInANewWindow } from '../actions/publicLazyActions';
import { previewAttachmentInPopOut } from 'owa-attachment-deeplink-popout';
import { orchestrator } from 'satcheljs';

orchestrator(openSxSInANewWindow, actionMessage => {
    let { parentItemId, attachmentId, isEdit, startTime } = actionMessage;

    if (!parentItemId || !attachmentId) {
        throw new Error('parentItemId or attachmentId is null');
    }

    previewAttachmentInPopOut(parentItemId, attachmentId, isEdit, startTime);
});
